// i18n keys of the multi-tenant work package "curwords" (owner Q18, 2026-10-03): what each country-pack
// currency is called inside a sentence. UI strings nest $t(cur_word) / $t(cur_adj) / $t(cur_unit), which
// src/utils/currencyWord.ts resolves to the entry of the {{cur}} in force for that t() call — no string names a currency.
// A code not listed here prints its ISO code. ⛔ Fill all three languages (an empty value falls back to English).
//   cw_<code>  — after an amount or in brackets: "1,000 baht", "Unit price (baht)"
//   cwa_<code> — attributive: "a baht total", "a Singapore dollar total" (zh / th: same as cw_)
//   cwu_<code> — a unit label printed the same in every language. Only THB has one: บาท, the Thai statutory
//                word the accounting screens already print in en / zh / th; any other code prints itself.
const CUR: Array<[string, string, string, string, string]> = [
  // code, en,                  en attributive,      zh,           th
  ['THB', 'baht',               'baht',              '泰铢',       'บาท'],
  ['SGD', 'Singapore dollars',  'Singapore dollar',  '新加坡元',   'ดอลลาร์สิงคโปร์'],
  ['MYR', 'ringgit',            'ringgit',           '林吉特',     'ริงกิต'],
  ['VND', 'dong',               'dong',              '越南盾',     'ดอง'],
  ['USD', 'US dollars',         'US dollar',         '美元',       'ดอลลาร์สหรัฐ'],
  ['IDR', 'rupiah',             'rupiah',            '印尼盾',     'รูเปียห์'],
  ['PHP', 'Philippine pesos',   'Philippine peso',   '菲律宾比索', 'เปโซฟิลิปปินส์'],
  ['HKD', 'Hong Kong dollars',  'Hong Kong dollar',  '港元',       'ดอลลาร์ฮ่องกง'],
  ['CNY', 'yuan',               'yuan',              '人民币',     'หยวน'],
  ['AUD', 'Australian dollars', 'Australian dollar', '澳元',       'ดอลลาร์ออสเตรเลีย'],
];
const UNIT: Record<string, string> = { THB: 'บาท' };
const col = (word: 1 | 3 | 4, adj: 2 | 3 | 4): Record<string, string> => Object.assign({},
  ...CUR.map(r => ({ ['cw_' + r[0]]: r[word], ['cwa_' + r[0]]: r[adj] })),
  ...Object.entries(UNIT).map(([c, u]) => ({ ['cwu_' + c]: u })));
export const en: Record<string, string> = col(1, 2);
export const zh: Record<string, string> = col(3, 3);
export const th: Record<string, string> = col(4, 4);
